import React from "react";
import { BRAND } from "../data/copperx";

const ABOUT_IMG =
  "https://images.pexels.com/photos/5288770/pexels-photo-5288770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt="Dubai skyline — SSR CopperX regional base"
                className="w-full h-[520px] object-cover"
                data-testid="about-image"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#18181B] text-white p-8 max-w-xs hidden md:block">
                <div className="text-[#E19672] text-xs tracking-[0.3em] uppercase font-semibold mb-2">
                  Headquarters
                </div>
                <div className="text-2xl font-medium leading-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
                  Dubai, UAE
                </div>
                <div className="font-mono text-xs text-[#94A3B8] mt-3">
                  Serving ME · Africa · Asia
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-rule" />
              <span className="text-[#B85C38] text-xs tracking-[0.3em] uppercase font-semibold">
                About SSR CopperX
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-[#0F172A] leading-[1.05] mb-8">
              A leading distributor of high-quality{" "}
              <span className="text-[#B85C38]">non-ferrous metal products</span>
              <span className="text-[#475569]"> for HVAC &amp; Refrigeration.</span>
            </h2>
            <p className="text-[#475569] text-lg leading-relaxed mb-6">
              <strong className="text-[#0F172A]">COPPERX</strong> is an established copper-tube brand
              endorsing high thermal &amp; electrical conductivity, excellent corrosion resistance,
              strength, ductility, and a wide operating temperature range. Our portfolio spans
              copper tubes, level-wound coils, copper fittings, and aluminium finstock.
            </p>
            <p className="text-[#475569] text-lg leading-relaxed mb-10">
              From our base in Dubai, we partner with MEP contractors, OEMs, and industrial
              projects across the Middle East, Africa, and Asia — supplying the
              high-performance copper that keeps the region's cooling, refrigeration, and
              critical piping systems running.
            </p>

            {/* Philosophy card */}
            <div className="border-l-4 border-[#B85C38] bg-[#F8F9FA] p-6 md:p-8" data-testid="philosophy-card">
              <div className="text-xs tracking-[0.3em] uppercase text-[#B85C38] font-semibold mb-3">
                Our Philosophy
              </div>
              <p className="text-[#0F172A] text-lg md:text-xl leading-snug" style={{ fontFamily: "Outfit, sans-serif" }}>
                "Committed to delivering exceptional value through unwavering focus on
                <span className="text-[#B85C38]"> Quality</span>,
                <span className="text-[#B85C38]"> Affordability</span>, and
                <span className="text-[#B85C38]"> Integrity</span>."
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-12 pt-10 border-t border-[#E2E8F0]">
              {[
                ["Quality", "ASTM compliant"],
                ["Reach", "ME · Africa · Asia"],
                ["Service", "Project-grade supply"],
              ].map(([k, v]) => (
                <div key={k}>
                  <div className="text-2xl font-medium text-[#0F172A]" style={{ fontFamily: "Outfit, sans-serif" }}>
                    {k}
                  </div>
                  <div className="text-sm text-[#475569] mt-1 font-mono">{v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
